<template>
    <!-- <v-menu v-model="dialogDependency" :nudge-width="200"
      offset-x :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-tooltip top>
          <v-btn :disabled="disabled || checkIsFree()" @click="reloadDependencies" slot="activator" small fab>
            <v-icon v-on="on" :color="dependencies.length === 0 ? 'black' : dependencies.some(dep => {return !dep.dependency.status || dep.dependency.status.identifier != 3}) ? 'red' : 'green'">mediation</v-icon>
          </v-btn>
          <span>{{checkIsFree() ? 'Seu plano não possui acesso a adição de pré-requisitos. Faça upgrade para o plano Business!' : 'Tarefas pré-requisitos'}}</span>
        </v-tooltip>
      </template> -->
  <v-dialog v-model="dialogDependency" @keydown.enter="confirm" @keydown.esc="cancel" max-width="400" persistent scrollable>
    <v-card :width="dependencyWidth" height="300" scrollable>
      <v-card-title style="padding-bottom: 0px; padding-top: 2px; height: 57px;">
        <v-autocomplete
          :items="tasks"
          :loading="loading"
          :search-input.sync="search"
          ref="autocomplete"
          :no-data-text="loading ? 'Carregando...' : 'Nenhuma tarefa encontrada'"
          multiple
          v-model="selectedTask"
          :filter="filterAutocomplete"
          item-text="id_text"
          item-value="id"
          @keyup.native="onChangeSearch"
          @focus="loadTasks()"
          @change="(val) => {selectTask(val)}"
          :label="template ? 'Tarefas que você participa' : 'Tarefas relacionadas a essa'"
          placeholder="Pesquise pelo id ou descrição da tarefa"
          return-object
        >
          <!-- @update:search-input="(val) => {typeSearch(val)}" -->
          <!-- <template v-slot:selection="data">
            {{data.item.identifier_sequence}} - {{data.item.id_text}}
          </template> -->
          <template  v-slot:item="data">
            <span style="overflow: hidden !important;text-overflow: ellipsis !important;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; word-break: break-all !important; margin-top: 0px !important;" v-if="template || data.item.id !== null">{{data.item.identifier_sequence}} - {{data.item.id_text}}</span>
            <v-layout style="background-color: teal; padding: 10px 2px; border-radius: 10px;" v-else-if="!showMoreLoading" justify-center align-centerv-else>
              <div class="show-more">
                Mostrar Mais
              </div>
            </v-layout>
            <v-layout  v-else justify-center align-centerv-else>
              <v-progress-linear :style="'margin: 4px;'" :indeterminate="true" :height="3" class="mb-0"></v-progress-linear>
            </v-layout>
          </template>
        </v-autocomplete>
        <!-- // v-if adicionado pois o info estava desconfigurando o layout do mobile -->
        <v-tooltip bottom v-if="!$vuetify.breakpoint.smAndDown" style="padding-bottom: 15px;padding-left: 15px;">
          <v-icon slot="activator" color="black">info</v-icon>
          <span><p-entire-field field="Adicione tarefas que você participa, que devem ser concluídas para que está possa ser executada. O responsável dessa tarefa, será notificado quando os pré-requisitos forem cumpridos."></p-entire-field></span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 188px;padding: 0px;" class="scroll">
        <v-layout v-if="loadingDependency" align-center justify-start column fill-height>
          <v-progress-linear :style="'margin: 4px;'" indeterminate :height="3" color="teal" class="mb-0"></v-progress-linear>
          <h2>Carregando...</h2>
        </v-layout>
        <v-layout v-else-if="dependencies.length === 0" align-center justify-start column fill-height>
          <h2>Nenhum registro adicionado</h2>
        </v-layout>
        <v-flex v-else class="text-sm-left">
          <!-- // loadingAddDependency Incluido para msotrar a barra de progresso quando adicionar uma dependencia sem sumir com os items -->
          <v-layout v-if="loadingAddDependency" align-center justify-start column fill-height>
            <v-progress-linear :style="'margin: 4px;'" indeterminate :height="3" color="teal" class="mb-0"></v-progress-linear>
          </v-layout>
          <v-list>
            <template v-for="(dep, index) in dependencies">
              <v-list-tile :key="index + 1000">
                <v-list-tile-avatar v-if="!template">
                  <p-task-date-icon
                    v-if="dep.dependency.end"
                    :onlyIcon="true"
                    :begin="dep.dependency.begin"
                    :end="dep.dependency.end"
                    :isMobileDesign="true"
                    :status_date="dep.dependency.status_date"
                    :commitment="dep.dependency.commitment"
                    :isFinalized="(dep.dependency.status && dep.dependency.status.identifier === 3)"
                  ></p-task-date-icon>
                  <v-tooltip v-else bottom>
                    <v-icon slot="activator" color="gray" size=20>lens</v-icon>
                    <span>Não possui data</span>
                  </v-tooltip>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-tooltip bottom class="text-sm-left">
                    <div slot="activator" style="overflow: hidden !important;text-overflow: ellipsis !important;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; word-break: break-all !important; margin-top: 0px !important;">
                      <router-link class="textTasks text-sm-left" v-if="checkPermission('tasks', 'manage') && !template" target="_blank" :to="`/task/${dep.dependency.id}?return=${'tasks'}`">
                        <span :style="dep.status && dep.status.identifier === 3 ? 'text-decoration: line-through;' : ''"><strong>{{(dep.dependency.identifier_sequence + ' - ' +  dep.dependency.id_text) | formatAbbreviation(70)}}</strong></span>
                      </router-link>
                      <span class="textTasks" v-else :style="dep.status && dep.status.identifier === 3 ? 'text-decoration: line-through;' : ''"><strong>{{(dep.dependency.identifier_sequence + ' - ' +  dep.dependency.id_text) | formatAbbreviation(70)}}</strong></span>
                    </div>
                    <span><p-entire-field :field="(dep.dependency.identifier_sequence + ' - ' +  dep.dependency.id_text)"></p-entire-field></span>
                  </v-tooltip>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon class="mx-0" @click="dependencyDelete(dep)">
                    <v-icon color="pink" :disabled="deleteInProgress">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < dependencies.length"
                :key="dep.id"
              ></v-divider>
            </template>
          </v-list>
        </v-flex>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-0" @click.native="dialogDependency = false">Sair</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable eqeqeq */
import PTaskDateIcon from './../shared/PTaskDateIcon'
import access from '../../mixin/access'
import PEntireField from './../shared/PEntireField'

export default {
  mixins: [access],
  components: {PEntireField, PTaskDateIcon},
  props: {
    task_id: {},
    task_top_id: {},
    template: false
  },
  data: () => ({
    tasks: [],
    loading: false,
    dependencyWidth: 600,
    search: '',
    showMoreLoading: false,
    selectedTask: [],
    taskPage: 1,
    deleteInProgress: false,
    dialogDependency: false,
    loadingDependency: false,
    loadingAddDependency: false,
    dependencies: [],
    searchEvent: null
  }),
  created () {
    // carregado todas as dependencias da tarefa corrente
    // if (!this.disabled) {
    // this.reloadDependencies(true)
    // }
    if (this.$vuetify.breakpoint.smAndDown) {
      this.dependencyWidth = 300
    }
  },
  methods: {
    // Possui os atributos taskId pois quando ver dos componentes superiores não da tempo de passar os valores por props
    reloadDependencies (toggle = this.dialogDependency, taskId = this.task_id) {
      if (toggle) {
        this.loadingDependency = true
        this.$http.get(`api/${this.template ? 'get_template_dependencies' : 'get_dependencies'}/${taskId}`).then(res => {
          this.dependencies = res.body === null ? [] : res.body
          this.loadingDependency = false
          this.updateDependencyLength()
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possivel carregas as depêndencias desta tarefa.',
            color: 'error',
            dialog: true
          })
        })
      }
    },
    openDialogDependency () {
      this.dialogDependency = true
    },
    updateDependencyLength () {
      let color = this.dependencies.length === 0 ? 'black' : this.dependencies.some(dep => { return !dep.dependency.status || dep.dependency.status.identifier != 3 }) ? 'orange' : 'green'
      this.$emit('updateDependencyLength', {total: this.dependencies.length, color: color})
    },
    // metodo criado para deleção das dependencias ao clicar no botão de deleção
    dependencyDelete (val) {
      // caso exista um deleção em progresso é avisado ao usuario
      if (this.deleteInProgress) {
        this.$store.commit('snackbar/change_values', {
          text: 'Já existe uma deleção em processo.',
          color: 'success',
          dialog: true
        })
      } else {
        this.deleteInProgress = true
        this.$http.delete(`api/${this.template ? 'tasktemplate_dependency' : 'task_dependency'}/${val.id}`).then(res => {
          this.dependencies = this.dependencies.filter(dep => {
            return dep.id !== val.id
          })
          this.$store.commit('snackbar/change_values', {
            text: 'Pré-requisito deletada com sucesso.',
            color: 'success',
            dialog: true
          })
          this.updateDependencyLength()
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível deletar o pré-requisito selecionado.',
            color: 'error',
            dialog: true
          })
        }).finally(() => {
          this.deleteInProgress = false
        })
      }
    },
    // função que acontence quando o usuário altera o campo de busca
    onChangeSearch () {
      // caso seja template já faz a busca na hora
      if (this.template) return
      this.loading = true
      this.tasks = []
      // limpado o timeout caso exista uma busca a ser feita
      clearTimeout(this.searchEvent)
      // carregada as tarefas utilizando o novo campo search
      this.searchEvent = setTimeout(() => {
        this.$http.get(`api/${this.template ? 'get_tasktemplates_to_depend' : 'get_tasks_depend'}/${this.task_id}?&page=${this.taskPage}&search=${this.search ? this.search : ''}`).then(res => {
          this.tasks = this.template ? res.body : res.body.data
          if (!this.template && res.body.last_page > 1) this.tasks.push({id: null})
          this.loading = false
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível buscar as tarefas, reporte o erro.',
            color: 'error',
            dialog: true
          })
        }).finally(() => { this.loading = false })
      }, 1500)
    },
    // função quando selecionado uma tarefa para ciração da dependencia
    selectTask (val) {
      this.loadingAddDependency = true
      val = val[0]
      // Limpa a tarefa selecionada pois ela já será adicionada na lista
      this.selectedTask = []
      // novo objeto de depencia criado a partir dos valores da tarefa selecionada
      if (typeof (val) === 'undefined' || val.id === null) {
        this.loadMoreTasks()
        return
      }
      this.$refs.autocomplete.blur()
      let values = this.template ? {tasktemplate_dependent_id: this.task_id, top_id: this.task_top_id, tasktemplate_dependency_id: val.id} : {task_dependent_id: this.task_id, task_dependency_id: val.id}
      this.$http.post(`api/${this.template ? 'tasktemplate_dependency' : 'task_dependency'}`, values).then(res => {
        this.loadingAddDependency = false
        // processo de inserção concluido
        this.$store.commit('snackbar/change_values', {
          text: 'Pré-requisito criado com sucesso.',
          color: 'success',
          dialog: true
        })
        this.dependencies.unshift(res.body)
        this.updateDependencyLength()
      }, err => {
        this.loadingAddDependency = false
        console.log(err)
        if (err.body.message === 'dependencyAlreadExists') {
          this.$store.commit('snackbar/change_values', {
            text: 'Pré-requisito já existe.',
            color: 'warning',
            dialog: true
          })
        } else if (err.body.message === 'isFinalized') {
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possivel criar o pré-requisito, a tarefa já foi concluída.',
            color: 'warning',
            dialog: true
          })
        } else {
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possivel criar o pré-requisito.',
            color: 'error',
            dialog: true
          })
        }
      }).finally(() => {
        this.$refs.autocomplete.blur()
        this.taskPage = 1
        // this.loadTasks()
      })
    },
    loadMoreTasks () {
      this.showMoreLoading = true
      this.selectedTask = []
      this.taskPage = this.taskPage + 1
      this.$http.get(`api/${this.template ? 'get_tasktemplates_to_depend' : 'get_tasks_depend'}/${this.task_id}?&page=${this.taskPage}&search=${this.search ? this.search : ''}`).then(res => {
        this.tasks.pop()
        this.tasks = this.tasks.concat(res.body.data)
        if (res.body.current_page !== res.body.last_page) this.tasks.push({id: null})
        this.loading = false
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {
          text: 'Não foi possivel carregar as tarefas.',
          color: 'error',
          dialog: true
        })
      }).finally(() => {
        this.showMoreLoading = false
      })
    },
    loadTasks () {
      // carregada as tarefas a serem utilizadas para criação de dependencias
      this.loading = true
      this.$http.get(`api/${this.template ? 'get_tasktemplates_to_depend' : 'get_tasks_depend'}/${this.task_id}?&page=${this.taskPage}&search=${this.search ? this.search : ''}`).then(res => {
        this.tasks = this.template ? res.body : res.body.data
        if (!this.template && res.body.last_page > 1) this.tasks.push({id: null})
        this.loading = false
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {
          text: 'Não foi possivel carregar as tarefas.',
          color: 'error',
          dialog: true
        })
      })
    },
    filterAutocomplete (item, queryText, itemText) {
      const hasValue = val => val != null ? val : ''
      const text = hasValue(item['identifier_sequence'] + ' - ' + item['id_text']).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return text.indexOf(query) > -1
    }
  }
}
</script>
<style scoped>
  .scroll {
    overflow-y: auto;
  }
  .show-more {
    cursor: pointer;
    height: 3px;
    background-color: teal;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .textTasks {
    word-break: break-all;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/PDependency.vue